/* ==========================================================================
   FLEXRAY — theme JavaScript
   Vanilla JS. No dependencies. Commerce via Shopify Cart AJAX API.
   ========================================================================== */
(function () {
  'use strict';

  var FR = window.FLEXRAY || {};
  var doc = document;

  /* ------------------------------------------------------------ utilities */
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function money(cents) {
    var fmt = FR.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      if (k === 'amount') return value;
      if (k === 'amount_no_decimals') return Math.round(cents / 100);
      if (k === 'amount_with_comma_separator') return value.replace('.', ',');
      return value;
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return r.ok ? d : Promise.reject(d); }); });
  }
  function getJSON(url) { return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) return Promise.reject(r.status); return r.json(); }); }

  /* ------------------------------------------------- overlay / drawer state */
  var overlay = $('[data-fr-overlay]');
  function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); } }
  function hideOverlay() { if (overlay) { overlay.classList.remove('is-visible'); setTimeout(function () { overlay.hidden = true; }, 320); } }

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    showOverlay();
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    hideOverlay();
  }
  on(overlay, 'click', function () { closeAll(); });
  function closeAll() {
    closePanel($('[data-fr-cart-drawer]'));
    closePanel($('[data-fr-mnav]'));
    closeModal();
  }
  on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* --------------------------------------------------------- mobile nav */
  var mnav = $('[data-fr-mnav]');
  on($('[data-fr-burger]'), 'click', function () { openPanel(mnav); });
  on($('[data-fr-mnav-close]'), 'click', function () { closePanel(mnav); });

  /* ========================================================== CART DRAWER */
  var drawer = $('[data-fr-cart-drawer]');
  var cartItemsEls = $$('[data-fr-cart-count]');

  function renderDrawer(cart) {
    if (!drawer) return;
    cartItemsEls.forEach(function (el) { el.textContent = cart.item_count; });

    var itemsEl = $('[data-fr-drawer-items]');
    var footEl = $('[data-fr-drawer-foot]');
    var emptyEl = $('[data-fr-drawer-empty]');
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.hidden = true;
      if (footEl) footEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    itemsEl.hidden = false;
    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image || '';
      var imgTag = img
        ? '<img class="fr-citem__img" src="' + img + '" alt="" loading="lazy">'
        : '<div class="fr-citem__img fr-placeholder" data-fr-label="IMG"></div>';
      return (
        '<div class="fr-citem" data-line-key="' + item.key + '">' +
          imgTag +
          '<div>' +
            '<p class="fr-citem__title">' + item.product_title + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="fr-citem__variant">' + item.variant_title + '</p>' : '') +
          '</div>' +
          '<div class="fr-citem__right">' +
            '<span class="fr-citem__price">' + money(item.final_line_price) + '</span>' +
            '<div class="fr-citem__controls">' +
              '<div class="fr-qty">' +
                '<button type="button" data-fr-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<input value="' + item.quantity + '" data-fr-qty-input readonly aria-label="Quantity">' +
                '<button type="button" data-fr-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="fr-citem__remove" data-fr-remove aria-label="Remove">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var subtotalEl = $('[data-fr-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    renderShipBar(cart);
  }

  function renderShipBar(cart) {
    var bar = $('[data-fr-shipbar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-fr-threshold'), 10) * 100;
    if (!threshold) { bar.closest('.fr-drawer__ship').hidden = true; return; }
    var remaining = threshold - cart.total_price;
    var fill = $('[data-fr-shipbar-fill]');
    var msg = $('[data-fr-shipbar-msg]');
    var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (remaining > 0) {
        msg.textContent = (bar.getAttribute('data-fr-msg') || 'Add {amount} more')
          .replace('{amount}', money(remaining));
      } else {
        msg.textContent = bar.getAttribute('data-fr-unlocked') || "You've unlocked FREE delivery";
      }
    }
  }

  function refreshCart() {
    return getJSON('/cart.js').then(function (cart) { renderDrawer(cart); return cart; });
  }

  /* drawer item events (delegated) */
  on(drawer, 'click', function (e) {
    var qtyBtn = e.target.closest('[data-fr-qty]');
    var removeBtn = e.target.closest('[data-fr-remove]');
    var item = e.target.closest('.fr-citem');
    if (!item) return;
    var key = item.getAttribute('data-line-key');
    if (qtyBtn) {
      var input = $('[data-fr-qty-input]', item);
      var newQty = parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-fr-qty'), 10);
      changeItem(key, Math.max(0, newQty));
    } else if (removeBtn) {
      changeItem(key, 0);
    }
  });

  function changeItem(key, qty) {
    post('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { renderDrawer(cart); })
      .catch(function () { alert(FR.strings && FR.strings.cartError); });
  }

  /* drawer note */
  var noteToggle = $('[data-fr-note-toggle]');
  var noteBox = $('[data-fr-note-box]');
  on(noteToggle, 'click', function () { noteBox.classList.toggle('is-open'); });
  on($('[data-fr-note-textarea]'), 'change', function (e) {
    post('/cart/update.js', { note: e.target.value }).catch(function () {});
  });

  function openCartDrawer() { if (drawer) { refreshCart(); openPanel(drawer); } }
  on($('[data-fr-cart-open]'), 'click', function (e) {
    if (window.matchMedia('(min-width: 990px)').matches && drawer) {
      e.preventDefault();
      openCartDrawer();
    }
  });
  on($('[data-fr-drawer-close]'), 'click', function () { closePanel(drawer); });

  /* ================================================= ADD TO CART (AJAX) */
  on(doc, 'submit', function (e) {
    var form = e.target.closest('[data-fr-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form) || form.querySelector('button');
    var offer = form.closest('[data-fr-pdp]') ? $('[data-fr-offer].is-selected', form.closest('[data-fr-pdp]')) : null;
    var items = [];

    if (offer) {
      $$('[data-fr-offer-item]', offer).forEach(function (row) {
        items.push({ id: row.getAttribute('data-fr-variant-id'), quantity: parseInt(row.getAttribute('data-fr-qty') || '1', 10) });
      });
    }
    if (!items.length) {
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return;
      items.push({ id: idInput.value, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 });
    }

    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    post('/cart/add.js', { items: items })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (drawer) { openPanel(drawer); } else { window.location.href = FR.cartUrl; }
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
        alert(msg);
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  });

  /* ================================================== PDP: variant picker */
  $$('[data-fr-pdp]').forEach(function (pdp) {
    var jsonScript = $('[data-fr-product-json]', pdp);
    var product = null;
    try { product = JSON.parse(jsonScript ? jsonScript.textContent : 'null'); } catch (e) { product = null; }
    if (!product) return;

    var variantInput = $('[data-fr-variant-input]', pdp);
    var priceWrap = $('[data-fr-price]', pdp);
    var atcBtn = $('[data-fr-atc-btn]', pdp);
    var qtyInput = $('[data-fr-qty-input]', pdp);
    var offers = $$('[data-fr-offer]', pdp);

    function currentSelection() {
      return $$('[data-fr-option]', pdp)
        .filter(function (el) { return el.checked; })
        .map(function (el) { return el.value; });
    }

    function findVariant(values) {
      return (product.variants || []).find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function updateOfferPrices(variant) {
      offers.forEach(function (offer) {
        $$('[data-fr-offer-item]', offer).forEach(function (row) {
          if (row.getAttribute('data-fr-is-main') === 'true') {
            var v = variant || (product.variants || [])[0];
            if (v) {
              row.setAttribute('data-fr-variant-id', String(v.id));
              var priceEl = row.querySelector('.fr-offer__item-price');
              if (priceEl) priceEl.textContent = money(v.price);
            }
          }
        });
      });
    }

    function update(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (qtyInput && qtyInput.hasAttribute('data-fr-variant-price')) {
        qtyInput.setAttribute('data-fr-variant-price', variant.price);
      }
      if (priceWrap) {
        var html = '';
        if (variant.compare_at_price > variant.price) {
          html = '<span class="fr-price fr-price--sale">' + money(variant.price) + '</span>' +
                 '<s class="fr-price fr-price--compare">' + money(variant.compare_at_price) + '</s>' +
                 '<span class="fr-badge fr-badge--sale">' +
                 'Save ' + money(variant.compare_at_price - variant.price) + '</span>';
        } else {
          html = '<span class="fr-price">' + money(variant.price) + '</span>';
        }
        priceWrap.innerHTML = html;
      }
      if (atcBtn) {
        var available = variant.available;
        atcBtn.disabled = !available;
        atcBtn.querySelector('[data-fr-atc-text]').textContent = available
          ? (FR.strings && FR.strings.addToCart) : (FR.strings && FR.strings.soldOut);
      }
      updateOfferPrices(variant);
    }

    $$('[data-fr-option]', pdp).forEach(function (el) {
      on(el, 'change', function () {
        var v = findVariant(currentSelection());
        if (v) update(v);
      });
    });
  });

  /* ==================================================== PDP: offer cards */
  $$('[data-fr-offer]').forEach(function (offer) {
    var input = $('input[type="radio"]', offer);
    on(input, 'change', function () {
      if (input.checked) {
        $$('[data-fr-offer]', doc).forEach(function (o) { o.classList.remove('is-selected'); });
        offer.classList.add('is-selected');
      }
    });
  });

  /* ========================================================= PDP gallery */
  $$('[data-fr-gallery]').forEach(function (gallery) {
    var main = $('[data-fr-gallery-main]', gallery);
    var modal = $('[data-fr-modal]');
    var modalImg = $('[data-fr-modal-img]');

    function setMedia(i) {
      var thumbs = $$('[data-fr-thumb]', gallery);
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (!main || !store) return;
      var node = $('[data-fr-media-node][data-fr-media-index="' + i + '"]', store);
      if (!node) return;
      main.innerHTML = '';
      main.appendChild(node.firstElementChild.cloneNode(true));
    }
    var store = $('[data-fr-media-store]', gallery);
    $$('[data-fr-thumb]', gallery).forEach(function (thumb) {
      on(thumb, 'click', function () { setMedia(parseInt(thumb.getAttribute('data-fr-media-index'), 10)); });
    });
    on(main, 'click', function () {
      var img = main.querySelector('img');
      if (img && modal && modalImg) {
        modalImg.src = img.src;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  function closeModal() {
    var modal = $('[data-fr-modal]');
    if (modal) modal.classList.remove('is-open');
    if (!drawer || !drawer.classList.contains('is-open')) document.body.style.overflow = '';
  }
  on($('[data-fr-modal-close]'), 'click', closeModal);
  on($('[data-fr-modal]'), 'click', function (e) { if (e.target === this) closeModal(); });

  /* =========================================================== hero slider */
  $$('[data-fr-hero]').forEach(function (hero) {
    var track = $('[data-fr-hero-track]', hero);
    var slides = $$('[data-fr-hero-slide]', hero);
    var dots = $$('[data-fr-dot]', hero);
    var interval = null;
    var i = 0;
    var delay = parseInt(hero.getAttribute('data-fr-autoplay') || '0', 10);

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    dots.forEach(function (d, idx) { on(d, 'click', function () { go(idx); reset(); }); });
    function reset() { if (interval) clearInterval(interval); if (delay) interval = setInterval(function () { go(i + 1); }, delay); }
    if (delay) reset();
  });

  /* ============================================================= carousels */
  $$('[data-fr-carousel]').forEach(function (carousel) {
    var track = $('[data-fr-carousel-track]', carousel);
    var prev = $('[data-fr-carousel-prev]', carousel);
    var next = $('[data-fr-carousel-next]', carousel);
    function step(dir) {
      var card = track.querySelector('[data-fr-carousel-slide]');
      if (!card) return;
      track.scrollBy({ left: dir * (card.offsetWidth + 18), behavior: 'smooth' });
    }
    on(prev, 'click', function () { step(-1); });
    on(next, 'click', function () { step(1); });
    track.addEventListener('scroll', function () {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }, { passive: true });
  });

  /* ================================================================== FAQ */
  $$('[data-fr-faq-item]').forEach(function (item) {
    var btn = $('[data-fr-faq-q]', item);
    var ans = $('[data-fr-faq-a]', item);
    on(btn, 'click', function () {
      var open = item.classList.toggle('is-open');
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0px';
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ======================================================= reveal on scroll */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); ro.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    $$('[data-fr-reveal]').forEach(function (el) { ro.observe(el); });
  } else {
    $$('[data-fr-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ========================================================= counters */
  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-fr-count'), 10) || 0;
    var suffix = el.getAttribute('data-fr-suffix') || '';
    var dur = 1600;
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if ('IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animateCounter(en.target); co.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    $$('[data-fr-count]').forEach(function (el) { co.observe(el); });
  }

  /* ======================================================= sticky ATC bar */
  var stickyBar = $('[data-fr-sticky-atc]');
  if (stickyBar) {
    var atcAnchor = $('[data-fr-atc-anchor]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var scrolledPast = en.boundingClientRect.bottom < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
        document.body.classList.toggle('fr-sticky-visible', scrolledPast);
      });
    }, { threshold: 0 });
    if (atcAnchor) io.observe(atcAnchor);
  }

  /* ====================================================== cart page forms */
  $$('[data-fr-cart-page]').forEach(function (page) {
    page.addEventListener('change', function (e) {
      if (e.target.matches('[data-fr-line-qty]')) {
        var input = e.target;
        var form = input.closest('form');
        if (form) form.submit();
      }
    });
  });

  /* ===================================================== problem card modals */
  $$('[data-fr-problem-card]').forEach(function (card) {
    var modal = $('[data-fr-problem-modal]', card);
    on(card, 'click', function (e) {
      if (e.target.closest('[data-fr-problem-close]')) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        return;
      }
      if (e.target === modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        return;
      }
      if (e.target.closest('.fr-problem-card__body') || e.target.closest('.fr-problem-card__plus') || e.target.closest('img') || e.target.closest('.fr-placeholder')) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  /* ===================================================== generic qty steppers */
  on(doc, 'click', function (e) {
    var btn = e.target.closest('[data-fr-qty]');
    if (!btn) return;
    if (btn.closest('[data-fr-drawer-items]')) return; /* drawer has its own handler */
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var val = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-fr-qty'), 10);
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ================================================ sticky ATC (mobile bar) */
  on($('[data-fr-sticky-atc-btn]'), 'click', function () {
    var form = $('[data-fr-atc-form]');
    if (form) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  /* initial cart render for badge counts */
  if (drawer || cartItemsEls.length) refreshCart();
})();
